// extracted by mini-css-extract-plugin
export default {"termDefContainer":"detailTermDefinition_termDefContainer__lIVMM"};